import moment from 'moment';
import 'moment/locale/es';

moment.locale('es');

const getDate = (data) => moment(data).format('DD-MM-YYYY HH:mm:ss');

export default getDate;
